<template>

<div style="position: relative">

    <div class="input-group">
      <input
        type="text"
        id="tf-routes-autocomplete"
        name="tf-routes-autocomplete"
        class="form-control"
        placeholder="Enter route, city or major destination"
        aria-label="Enter route, city or major destination"
        aria-describedby="tf-routes-autocomplete"
        v-model="textquery"
        @focus="focusHandler"
        @blur="blurHandler"
        @keyup.esc="setBlurHandler"
        @keyup="textChangeHandler($event)">
    </div>
    <i class="icon-icon-close-small-blue"
        v-if="textquery.length > 0"
        @click="clearTextField"></i>

    <transition name="fade-quick">
    <div v-if="textfieldFocused">
      <div class="dropdown-list text-dark" v-if="textquery.length < 1">
        <div class="sub-header">Recent</div>
        <div v-for="(item, index) in routesHistory" style="position: relative"
             class="item"
             :key="'history-route' + index"
             @click="selectRouteFromList(item)">
             <i class="icon-icon-bus" v-if="item.field_mode === 'bus'"></i>
             <i class="icon-icon-light-rail" v-if="item.field_mode === 'lightrail'"></i>
            <span class="route-no">{{ item.title }}</span>
            <span class="route-name" v-if="!isFuture && item.field_old_endpoint">{{ item.field_old_endpoint.join(" - ") }}</span>
            <span class="route-name" v-if="isFuture && item.field_new_endpoint">{{ item.field_new_endpoint.join(" - ") }}</span>
        </div>
      </div>
      <div class="dropdown-list text-dark" v-if="textquery.length > 0">
          <div v-for="(item, index) in routesFiltered"
               class="item"
               :key="'route-' + index"
               @click="selectRouteFromList(item)">
            <i class="icon-icon-bus" v-if="item.field_mode === 'bus'"></i>
            <i class="icon-icon-light-rail" v-if="item.field_mode === 'lightrail'"></i>
            <span class="route-no">{{ item.title }}</span>
            <span class="route-name" v-if="!isFuture && item.field_old_endpoint">{{ item.field_old_endpoint.join(" - ") }}</span>
            <span class="route-name" v-if="isFuture && item.field_new_endpoint">{{ item.field_new_endpoint.join(" - ") }}</span>
          </div>
      </div>
    </div>
    </transition>

</div>

</template>

<script>
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'


export default {
  name: 'routes-search-autocomplete',
  props: ['routesData', 'isFuture'],
  mixins: [mixinCommon, mixinFilters],
  data () {
    return {
        textquery: '',
        textfieldFocused: false,
        ignoreFocus: false,
        maxNo: 10,
        routesHistory: []
    }
  },
  computed: {
    routesFiltered () {
      // routes are searched against the text query based on city/endpoints and title
      let result = {}
      if (this.textquery.length < 1) {
        return result
      }
      for (let key in this.routesData) {
        let route = this.routesData[key];
        let match = false;
        // skip old routes if show future routes
        if (this.isFuture && route.field_status.length === 1 && route.field_status.indexOf("Old") > -1) {
          continue;
        }
        if ((route.title+'').toLowerCase().substr(0, this.textquery.length) === this.textquery.toLowerCase() ||
            (this.isFuture && (route.field_new_city.toLocaleString().toLowerCase().indexOf(this.textquery.toLowerCase()) > -1 ||
                               route.field_new_poi.toLocaleString().toLowerCase().indexOf(this.textquery.toLowerCase()) > -1 ||
                               route.field_old_route.find(x => String(x) === String(this.textquery)) ||
                               route.field_new_endpoint.toLocaleString().toLowerCase().indexOf(this.textquery.toLowerCase()) > -1)) ||
            (!this.isFuture && (route.field_old_city.toLocaleString().toLowerCase().indexOf(this.textquery.toLowerCase()) > -1 ||
                               route.field_old_poi.toLocaleString().toLowerCase().indexOf(this.textquery.toLowerCase()) > -1 ||
                               route.field_old_endpoint.toLocaleString().toLowerCase().indexOf(this.textquery.toLowerCase()) > -1))
          ) {
          match = true;
        }
        if (match) {
          result[key] = route;
        }
      }
      if (Object.keys(result).length > this.maxNo) {
        result = Object.keys(result).slice(0, this.maxNo).map(x => result[x])
      }
      return result
    }
  },
  watch: {
    // address () {
    //   this.focusTextfield()
    // }
  },
  methods: {
    textChangeHandler (e) {
      // this.textquery = e.target.value
    },
    focusHandler (e) {
        this.textfieldFocused = true
    },
    blurHandler (e) {
        setTimeout(() => this.textfieldFocused = false, 150)
    },
    setBlurHandler (e) {
      e.target.blur()
      // this.textfieldFocused = true
    },
    focusTextfield () {
      console.log("focusTextfield", this.ignoreFocus)
      if (this.ignoreFocus) {
        this.ignoreFocus = false
        return
      }
      if (!this.textfieldFocused) {
          return
      }
    },
    clearTextField (e) {
      this.textquery = ''
      this.textfieldFocused = true
      // let storeAction = (this.type === 'origin') ? 'tripPlanner/SET_INPUT_ORIGIN' : 'tripPlanner/SET_INPUT_DESTINATION'
      // this.$store.commit(storeAction, { name: '', lat: '', lng: '', type: '' })
    },
    selectRouteFromList (route) {
      this.addRouteToHistory(route)
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-routes-all' : 'routes-all',
          params: { routeOrLink: route.field_mode, routeNo: route.title}
        });
    },
    getRoutesHistory () {
      if (!localStorage['routes-history']) {
          localStorage['routes-history'] = '[]'
      }
      if (localStorage['routes-history']) {
        this.routesHistory = JSON.parse(localStorage['routes-history'])
      }
    },
    addRouteToHistory (route) {
      this.getRoutesHistory()
      this.routesHistory.unshift(Object.assign({}, route, { timestamp: moment().unix() }))
      let total = this.routesHistory.length;
      let max = 3;
      if (total > max) {
          this.routesHistory = this.routesHistory.splice(0, max)
      }
      localStorage['routes-history'] = JSON.stringify(this.routesHistory)
    },
  },
  mounted () {
    this.getRoutesHistory();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../sass/_variables.scss';

.dropdown-list {
    left:0;
    right:0;
    position: absolute!important;
    background-color: #fff;
    z-index: 1000;
    border-radius: 2px;
    border-top: 1px solid #d9d9d9;
    font-family: Arial,sans-serif;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
}
.dropdown-list .sub-header {
    font-size:11px;
    background-color: #ddd;
    padding: 2px;
}
.dropdown-list .item {
    cursor: default;
    padding: 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 30px;
    text-align: left;
    border-top: 1px solid #e6e6e6;
    font-size: 14px;
    color: $dark-blue;
}
.dropdown-list .item:hover {
    background-color: #eee;
}
.dropdown-list .item .item-icon {
  width: 15px;
  height: 20px;
  margin: 1px 4px;
  display: inline-block;
}

.dropdown-list .item .route-no {
  font-weight: bold;
  font-size: 16px;
  background-color: $dark-blue;
  color: $white-color;
  width:40px;
  height: 40px;
  margin-right: 10px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 50%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
}

.input-group-prepend span {
    min-width: 68px;
}
[class^="icon-icon-close-small-blue"] {
    position: absolute;
    top: 10px;
    right:10px;
    cursor: pointer;
    z-index: 99;
}

.icon-icon-bus, .icon-icon-light-rail {
  font-size:32px;
  min-width: 32px;
  display: inline-flex;
  vertical-align: middle;
  margin-left: 8px;
  margin-right: 12px;
}

input[type=text] {
  padding-right: 30px;
}
.highlight {
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/RoutesSearchAutocomplete.vue